import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  img: {
    borderRadius: 21,
    //width: '100%',
    boxShadow: "0px 2px 25px rgba(0,0,0,0.4)"
  },
  center: {
    textAlign: 'center'
  }
});

class Image extends Component {

  render() {
    const { classes, src, alt, width } = this.props;

    const params = {
      width: width ? width : '100%'
    };

    return (
      <div className={classes.center}>
        <img src={src} className={classes.img} alt={alt} {...params} />
      </div>
    )
  }
}

Image.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Image);
